import { gql } from '@apollo/client'

export const CREATE_USER = gql`
  mutation newUserCreation($uuid: ID!, $emailAddress: EmailAddress!, $password: String!, $invitationID: ID! ) {
    createAccountByInvitation(uuid: $uuid, emailAddress: $emailAddress, password: $password, invitationID: $invitationID)
  }
`
